export enum IceDashboardDisplayStateEnum {
    SUCCESS = 'success',
    WARNING = 'warning',
    DANGER = 'danger',
    NEUTRAL = 'neutral',
}
